<template>
  <div class="accodion_box accodion_arimtalk accodion_abc">
    <div class="accodion_box_tit">
      <a href="#target_arimtalk" data-toggle="collapse" aria-expanded="true">
        <div class="panel-title">
          <span class="text-uppercase accordion-header-text"
            >알림톡 (SMS) 받기 설정</span
          >
          <span class="pull-right icon-arr"></span>
        </div>
      </a>
    </div>
    <div
      id="target_arimtalk"
      class="accodion_box_cont0 collapse in"
      role="tabpanel"
      aria-expanded="true"
    >
      <div class="accodion_box_cont">
        <div class="tab-area with50">
          <div class="tab-head">
            <input
              class="amwa-checkbox"
              type="checkbox"
              id="notificationAgreed"
              v-model="localIsReceiveAgreed"
              @change="
                $emit('update-sms-receive', {
                  isReceiveAgreed: $event.target.checked,
                  receivePhone: localReceivePhone,
                })
              "
            />
            <label for="notificationAgreed" class="focus">알림 받기 동의</label>
          </div>
        </div>
        <div class="form_group_a with_side mgt10">
          <div class="payment-item-a">
            <div class="payment-title">
              <div class="payment-item-title">
                <div class="withTooltip">
                  <span class="sstit">휴대폰 번호</span>
                  <!-- 툴팁 -->
                  <div
                    class="toolTip-wrapper toolTip-type02 type-mob-full"
                    :class="classToolTip"
                  >
                    <button
                      type="button"
                      class="btn-tooltip"
                      @click="isTooltipOpen = !isTooltipOpen"
                    >
                      <span class="hidden">안내</span>
                    </button>
                    <div class="tipCont-wrapper" style="max-width: none">
                      <div class="tooltip-content" :style="styleToolTip">
                        <ul class="list-type5">
                          <li>
                            상담 / 결제 / 배송 등 마이팩 관련 안내 메시지 수신여부를 설정합니다.
                          </li>
                          <li>
                            알림 받기를 동의하신 경우에만 입력하신 번호로 결제
                            관련 안내가 제공됩니다.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <!-- //툴팁 -->
                </div>
              </div>
            </div>
            <div class="payment-content">
              <div class="form-item-a mobile">
                <input
                  name="receive_phone"
                  id="receive_phone"
                  type="text"
                  class="form_input"
                  placeholder="'-' 없이 입력"
                  v-model="localReceivePhone"
                  @change="
                    $emit('update-sms-receive', {
                      isReceiveAgreed: isReceiveAgreed,
                      receivePhone: localReceivePhone,
                    })
                  "
                />
              </div>
            </div>
            <div class="payment-content2">
              <input
                id="chk_use_02"
                type="checkbox"
                :checked="localReceivePhone === aboPhone"
                @change="updateAboPhone"
              /><label for="chk_use_02" class="focus">주문자와 동일</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SmsReceive",
  props: {
    isReceiveAgreed: {
      type: Boolean,
      default: false,
    },
    receivePhone: {
      type: String,
      default: "",
    },
    aboPhone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localIsReceiveAgreed: this.isReceiveAgreed,
      localReceivePhone: this.receivePhone,
      isTooltipOpen: false,
    };
  },
  watch: {
    isReceiveAgreed(newVal) {
      this.localIsReceiveAgreed = newVal;
    },
    receivePhone(newVal) {
      this.localReceivePhone = newVal;
    },
  },
  mounted() {
    document.addEventListener("click", this.closeTooltip);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeTooltip);
  },
  computed: {
    classToolTip() {
      return this.isTooltipOpen ? "open" : "";
    },
    styleToolTip() {
      return this.isTooltipOpen ? { display: "block" } : { display: "none" };
    },
  },
  methods: {
    updateAboPhone(event) {
      if (event.target.checked) {
        this.localReceivePhone = this.aboPhone;
      } else {
        this.localReceivePhone = "";
      }
      this.$emit("update-sms-receive", {
        isReceiveAgreed: this.localIsReceiveAgreed,
        receivePhone: this.localReceivePhone,
      });
    },
    closeTooltip(event) {
      // 툴팁 내부를 클릭했으면 닫지 않음
      if (this.$el.querySelector(".toolTip-wrapper").contains(event.target)) {
        return;
      }
      this.isTooltipOpen = false;
    },
  },
};
</script>
<style>
</style>